import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Home,
  Search as SearchIcon,
  Headphones,
  Rss,
  Bookmark,
} from 'lucide-react';
import { key_searchPageUrl, searchHistory } from '../util/constants';

// Bottom navigation for phones. Hidden on md+ and inside the book reader.
const MobileTabBar = () => {
  const location = useLocation();
  if (location.pathname.startsWith('/books/')) return null;

  const tabs = [
    { to: '/', label: 'Home', icon: Home, end: true },
    {
      to: searchHistory.get(key_searchPageUrl) || '/search',
      label: 'Search',
      icon: SearchIcon,
      match: '/search',
    },
    { to: '/listen', label: 'Listen', icon: Headphones },
    { to: '/feed', label: 'Feed', icon: Rss },
    { to: '/bookmarks', label: 'Saved', icon: Bookmark },
  ];

  return (
    <nav
      aria-label="Main"
      data-hide-bar="bottom"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-5 border-t border-slate-200 bg-white/95 backdrop-blur md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {tabs.map(({ to, label, icon: Icon, end, match }) => {
        const forceActive = match && location.pathname === match;
        return (
          <NavLink
            key={label}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex h-16 flex-col items-center justify-center gap-0.5 text-[11px] no-underline ${
                isActive || forceActive
                  ? 'font-bold text-indigo-700'
                  : 'font-medium text-slate-500'
              }`
            }
          >
            <Icon size={22} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
